export default (state) => state.users && state.users.data
